var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCreateNewHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "button/create new/hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.9305556,10.8333333 L11.1111111,10.8333333 L11.1111111,15 C11.1111111,15.4583333 10.7673611,15.8333333 10.3472222,15.8333333 C9.92708333,15.8333333 9.58333333,15.4583333 9.58333333,15 L9.58333333,10.8333333 L5.76388889,10.8333333 C5.34375,10.8333333 5,10.4583333 5,10 C5,9.54166667 5.34375,9.16666667 5.76388889,9.16666667 L9.58333333,9.16666667 L9.58333333,5 C9.58333333,4.54166667 9.92708333,4.16666667 10.3472222,4.16666667 C10.7673611,4.16666667 11.1111111,4.54166667 11.1111111,5 L11.1111111,9.16666667 L14.9305556,9.16666667 C15.3506944,9.16666667 15.6944444,9.54166667 15.6944444,10 C15.6944444,10.4583333 15.3506944,10.8333333 14.9305556,10.8333333 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button/create-new/hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/add"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button-placer",
    fill: "#FFFFFF",
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Neutral-Fill",
    mask: "url(#mask-2)",
    fill: "#5697B7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Fill",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreateNewHover);
export default __webpack_public_path__ + "static/media/icon_create_new_hover.98e8132a950c80d0d9c050ee8699fb60.svg";
export { ForwardRef as ReactComponent };